
import React, { useCallback } from 'react'
import { useDispatch } from 'react-redux';
import { useForm } from '../../hooks/useForm';
import * as ActionTypes from '../actions/actionTypes'

export const useDocument=({actionType,tableName,containerKey})=>{
 const {isLoading,saveForm,deleteForm}=useForm(containerKey)
 const dispatch = useDispatch();
  const AddItem = useCallback(async(callback) => {
     try{
       
        const response=await saveForm({[`${tableName}`]:[{id:""}]})
        if(response){
        dispatch({
            type: ActionTypes[`ADD_ITEM_${actionType}`],
            payload:{id:response.responseMessage},
            meta:{tableName:tableName}
        })
        callback && callback(response)
        }
     }
     catch(e){

     }
  }, []);

  const deleteItem = useCallback(async(id) => {
    try{
         const response=await deleteForm({[`${tableName}`]:[{id}]})
         if(response)
        dispatch({ type:ActionTypes[`DELETE_ITEM_${actionType}`],id,meta:{tableName:tableName}}) 
      
     }
     catch(e){

     }
 }, []);

 const updateItem = useCallback((id,payload) => {
    try{
        dispatch({
            type:ActionTypes[`UPDATE_ITEM_${actionType}`],
            id,
            payload,
            meta:{tableName:tableName}
        })
    }
    catch{

    }
 }, []);

 const saveItem = useCallback(async(payload) => {
    try{
        const response=await saveForm({[`${tableName}`]:Array.isArray(payload) ? payload: [payload]},false)
    }
    catch{

    }
 }, [saveForm]);

 const updateAllItems=useCallback((payload)=>{
    dispatch({
        type:ActionTypes[`UPDATE_ALL_ITEMS_${actionType}`],
        payload,
        meta:{tableName:tableName}
    })
 },[])

  return {isLoading,AddItem,deleteItem,updateItem,saveItem,updateAllItems}
}